import { Tooltip, TooltipContent, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { Icon } from '../../../elementsv2'
import { Box } from 'lucide-react'

type Props = { className?: string; count?: number }

export const IntegrationCountBadge = ({ count = 0, ...props }: Props) => {
  return (
    <Tooltip>
      <TooltipContent>Integrations</TooltipContent>
      <TooltipTrigger>
        <div className="flex items-center gap-1" {...props}>
          <Icon variant="outline" color="gray" icon={Box} />
          <span className="text-xs text-gray-11">{count}</span>
        </div>
      </TooltipTrigger>
    </Tooltip>
  )
}
